import { InputForm } from "../types";
import {Team} from "../types/teams.types";
import {Group} from "../types/groups.types";

export const ALERT_COLUMNS = [
    {
        field: 'userName',
        headerName: 'User Name',
        width: 350,
    },
    // NOTE: `field` here is a stable identifier for the column slot — it
    // does NOT have to map to a property path on the alert document. The
    // table cells in alerts-list/index.tsx render manually (e.g.
    // `alert?.user?.group?.name` for Group), so `field` is a
    // display-side label. Matches the same convention USER_COLUMNS uses.
    {
        field: 'groupName',
        headerName: 'Group',
        width: 150,
        // Same opt-out as USER_COLUMNS — group is joined server-side
        // (team.groupId → Groups) and is not a sortable alert field.
        sortable: false,
    },
    {
        field: 'teamId',
        headerName: 'Team',
        width: 350,
    },
    {
        field: 'userPhone',
        headerName: 'User Phone Number',
        width: 350,
    },
    {
        field: 'initiatedBy',
        headerName: 'Initiated By',
        width: 350,
    },
    {
        field: 'alertType',
        headerName: 'Alert Type',
        width: 350,
    },
    {
        field: 'initiatedAt',
        headerName: 'Initiated At',
        width: 350,
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 350,
    },
];

export const getAlertFilterInputs = (allTeams : Team[], allGroups : Group[]) : InputForm[] => {
    return [
        {
            label: 'User Name',
            id: 'initiatedBy',
            type: 'text',
            required: false,
            placeholder: 'Filter by user name',
            grid: {
                xs: 4,
                sm: 4,
                md: 4,
            },
        },
        {
            label: 'Status',
            id: 'status',
            type: 'select',
            required: false,
            placeholder: 'Filter by alert status',
            options : [
                {label:'None',value:''},
                {label:'Active',value:'active'},
                {label:'Resolved',value:'resolved'},
                {label:'Reviewed',value:'reviewed'},
                {label:'Pending Review',value:'pending-review'},
            ],
            grid: {
                xs: 4,
                sm: 4,
                md: 4,
            },
            sx : {mr:2}
        },
        {
            label: 'Alert Type',
            id: 'alertType',
            type: 'select',
            required: false,
            options : [
                {label:'None',value:''},
                {label:'VisitRiskReview',value:'RiskReview'},
                {label:'CheckOnMe',value:'CheckOnMe'},
                {label:'FakeCall',value:'FakeCall'},
                {label:'SOS',value:'SOS'},
                {label:'Shift',value:'Shift'},
            ],
            placeholder: 'Filter by alert type',
            grid: {
                xs: 4,
                sm: 4,
                md: 4,
            },
        },
        {
            label: 'Team',
            id: 'teamId',
            type: 'select',
            required: false,
            options : [...getSelectOptions(allTeams)],
            placeholder: 'Filter by Team',
            sx : {mr:2},
            grid: {
                xs: 4,
                sm: 4,
                md: 4,
            },
        },
        {
            label: 'Group',
            id: 'teamIds',
            type: 'select',
            required: false,
            options : [...getSelectOptions(allGroups,'teamIds')],
            placeholder: 'Filter by Group',
            grid: {
                xs: 4,
                sm: 4,
                md: 4,
            },
        }
    ];
}

const getSelectOptions = (entity : any, key ?: string) : [] => {
    let selectOptions = entity.map((item : any) => {
        return {label: item?.name, value: item?.[key ?? 'id']};
    })
    selectOptions = [{label: 'None', value: ''},...selectOptions];
    return selectOptions;
}